import RTypePlaces from './RTypePlaces';

export default RTypePlaces;
